import http from '../http/index'
// service-ecare/rest/general/oss/policy
export default {
  loadOSSToken: function loadOSSToken (callback) {
    http.post("/rest/my/oss/policy", {}, function (res) {
      callback(res)
    }, function (error) {

    })
    // let url = '/zzb-api/rest/my/oss/policy?scheme=' + document.location.protocol.substring(0, document.location.protocol.length - 1)
    // http.get(url, null, res => {
    //   response(res)
    // })
  }
}



// WEBPACK FOOTER //
// ./src/assets/api/oss.js